import { render } from "./StatusLabel.vue?vue&type=template&id=1b7a2dcb&scoped=true"
import script from "./StatusLabel.vue?vue&type=script&lang=js"
export * from "./StatusLabel.vue?vue&type=script&lang=js"

import "./StatusLabel.vue?vue&type=style&index=0&id=1b7a2dcb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7a2dcb"]])

export default __exports__